var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"btn btn-primary mb-2 row",on:{"click":function($event){return _vm.$emit('view-coupons')}}},[_c('i',{staticClass:"fas fa-tags fa-rotate-90 fa-align-left fa-2x"}),_vm._v(" "),_c('div',{staticClass:"d-inline-block"},[_vm._v(_vm._s(_vm.couponName))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03e6a682","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/business/rightSide/RightSide.vue
// module id = null
// module chunks = 